var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorldOutlined = function SvgWorldOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E89A1",
    fillRule: "evenodd",
    d: "M10.501 18.33a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.667m-4.976-7.666c.164 2.307 1.174 4.39 2.733 5.966a7.01 7.01 0 0 1-4.725-5.966zm1.337 0c.186 2.225 1.292 4.214 2.973 5.604v-5.604zm4.306 5.604c1.681-1.39 2.787-3.38 2.972-5.604h-2.972zm4.31-5.604c-.165 2.307-1.174 4.39-2.733 5.966a7.01 7.01 0 0 0 4.725-5.966zm1.992-1.333h-1.992c-.165-2.307-1.174-4.39-2.733-5.966A7.01 7.01 0 0 1 17.47 9.33m-3.33 0h-2.972V3.727c1.681 1.39 2.787 3.38 2.972 5.604M9.835 3.727v5.604H6.862c.186-2.225 1.292-4.214 2.973-5.604m-4.31 5.604H3.533a7.01 7.01 0 0 1 4.725-5.966C6.698 4.94 5.689 7.024 5.525 9.33",
    clipRule: "evenodd"
  })));
};
export default SvgWorldOutlined;